import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import MonthlyShiftRegistration from "../components/MonthlyShiftRegistration";

/**
 * 管理側：指定社員の月間スケジュール登録（出退勤管理の「スケジュール未登録」から遷移）
 */
const AdminEmployeeSchedule = () => {
  const { memberId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const name = location.state?.name || "";

  if (!memberId) {
    return (
      <div style={{ padding: 24 }}>
        <p>社員コードが指定されていません。</p>
        <button type="button" onClick={() => navigate("/admin/workstime/schedule")}>戻る</button>
      </div>
    );
  }

  return (
    <div className="admin-employee-schedule-page" style={{ padding: 16 }}>
      <MonthlyShiftRegistration
        memberId={memberId}
        name={name}
        onRegistrationComplete={() => navigate("/admin/workstime/schedule")}
        onBack={() => navigate("/admin/workstime/schedule")} 
      />
    </div>
  );
};

export default AdminEmployeeSchedule;